/**
 * Descarga el pedido en PDF para imprimirlo (ADM-09): logo, lo comprado con
 * su foto, totales, cliente, entrega y pago. Lo arma el servidor.
 *
 * Dos formas: el icono de la columna de la tabla de pedidos y el boton con
 * texto del modal. Mientras baja queda deshabilitado, para que un doble clic
 * no lo pida dos veces; si falla, lo dice en un aviso.
 */
import { useState } from 'react';

import { descargarPedidoPdf } from '../../servicios/administracion.servicio';
import { descargarArchivo } from '../../utilidades/descargar-archivo';
import { Icono } from '../comunes/Icono';
import { ModalAviso } from './ModalAviso';

export interface BotonPdfPedidoProps {
  id: number;
  referencia: string;
  forma: 'icono' | 'boton';
}

export function BotonPdfPedido({ id, referencia, forma }: BotonPdfPedidoProps) {
  const [bajando, setBajando] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function descargar() {
    setBajando(true);
    try {
      descargarArchivo(await descargarPedidoPdf(id), `Pedido-${referencia}.pdf`);
    } catch (falla) {
      setError(falla instanceof Error ? falla.message : 'No pudimos armar el PDF del pedido.');
    } finally {
      setBajando(false);
    }
  }

  return (
    <>
      <button
        type="button"
        className={forma === 'icono' ? 'btn-icono boton-pdf' : 'btn btn-sm btn-contorno'}
        onClick={() => {
          void descargar();
        }}
        disabled={bajando}
        aria-busy={bajando}
        {...(forma === 'icono' ? { 'aria-label': `Descargar el pedido ${referencia} en PDF`, title: 'Descargar PDF' } : {})}
      >
        <Icono nombre="pdf" />
        {forma === 'boton' ? (bajando ? 'Preparando PDF…' : 'Descargar PDF') : null}
      </button>
      <ModalAviso
        titulo="No se pudo descargar el PDF"
        mensaje={error}
        onCerrar={() => {
          setError(null);
        }}
      />
    </>
  );
}
